import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/DealerLogin.css";
import CryptoJS from "crypto-js";
import axios from "axios";
import qs from "qs";
import SHA256 from "crypto-js/sha256";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // 👈 Import eye icons

const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
    const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
    const message = `${method}${urlPath}${timestamp}`;
    return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

function DealerLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedRoId, setSelectedRoId] = useState(null);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        const method = "POST";
        const urlPath = "/v1/user/login";
        const timestamp = Math.floor(Date.now() / 1000).toString();
        const signature = generateSignature(method, urlPath, timestamp);

        const formData = qs.stringify({ username, password });

        try {
            const response = await axios.post(
                `${API_BASE_URL}${urlPath}`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "X-Signature": signature,
                        "X-Timestamp": timestamp,
                    },
                }
            );

            console.log("Backend Response:", response.data);

            if (response.status >= 200 && response.status < 300) {
                const accessToken = response.data?.access_token;

                if (accessToken) {
                    localStorage.setItem("authToken", accessToken);
                    localStorage.setItem("userProfile", JSON.stringify(response.data));

                    // Fetch the RO list after login to get the selectedRoId
                    const fetchRoList = async () => {
                        const timestamp = Math.floor(Date.now() / 1000).toString();
                        const userUrlPath = "/v1/user/ros";
                        const userSignature = generateSignature("GET", userUrlPath, timestamp);

                        try {
                            const roResponse = await axios.get(`${API_BASE_URL}${userUrlPath}`, {
                                headers: {
                                    Authorization: `Bearer ${accessToken}`,
                                    "X-Signature": userSignature,
                                    "X-Timestamp": timestamp,
                                },
                            });

                            if (roResponse.data.ro_list && roResponse.data.ro_list.length > 0) {
                              
                                // If no RO is selected, default to the first RO
                                const defaultRoId = roResponse.data.ro_list[0].id;
                                setSelectedRoId(defaultRoId);
                                localStorage.setItem("selectedRoId", defaultRoId);
                            }
                        } catch (error) {
                            console.error("Error fetching RO list:", error);
                        }
                    };

                    fetchRoList();
                    navigate("/dashboard");
                } else {
                    throw new Error("Access token missing in response.");
                }
            } else {
                throw new Error(`Unexpected status: ${response.status}`);
            }
        } catch (error) {
            console.error("Login Error:", error.response || error.message);

            const errorMessage =
                error.response?.data?.detail ||
                error.response?.data?.message ||
                "Login failed. Please try again.";

            setMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    

    return (
        <div className="main-container">
            <Header />
            <div className="login-container">
                <form onSubmit={handleLogin}>
                    <h2>Dealer Login</h2>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                className="icon-button"
                                aria-label="Toggle password visibility"
                            >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
                {message && <p className="message">{message}</p>}

                
            </div>
            <Footer />
        </div>
    );
}

export default DealerLogin;
